"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const keautils_1 = require("keautils");
const _moize = require("moize");
const moize = keautils_1.interopRequireDefault(_moize);
const bind_1 = require("./bind");
const cache_1 = require("./cache");
/**Función que memoiza una función comparando profundamente los argumentos, tiene un tamaño de cache de 16, es util para memoizar las funciones de los resources */
const moizeDeep = (func, maxSize = 16) => moize(func, { equals: keautils_1.deepEquals, maxSize: maxSize });
function getCacheResourceFunctionInstance(memo, invalidates) {
    return function func(...args) {
        const resource = bind_1.getResourceFromThis(this);
        const memoResult = memo(...args);
        if (keautils_1.isPromiseLike(memoResult)) {
            //Si la funcion original devuelve una promesa, nos vamos por la ruta asíncrona
            const ret = (async () => {
                //Nos esperamos a que se obtenga el resultado
                try {
                    const memoResultSync = await memoResult;
                    return memoResultSync;
                }
                catch (error) {
                    //Limpiamos el cache, ya que si lanza error la logica es que no se debe de almacenar en el cache
                    if (typeof (memo.clear) == "function")
                        memo.clear();
                    throw error;
                }
                finally {
                    //Solo despues invalidamos
                    if (invalidates) {
                        await cache_1.invalidateResource(resource);
                    }
                }
            })();
            return ret;
        }
        else {
            //Si la funcion original no devuelve promesa, la funcion resulatante tampoco debe de devolver una
            //Llamamos a manera de disparar y olvidar el invalidateResource
            if (invalidates) {
                cache_1.invalidateResource(resource);
            }
            return memoResult;
        }
    };
}
/**Devuelve una función que tiene asignada la función de invalidar. Si ambos memoize e invalidates == false devuelve el mismo func.
 * Recuerde que para que funcione un resource con cache debe de ser tratado por la función bindResource después de la composición.
 * @param oringFunc Función que se quiere memoizar
 * @param memoize Indica si la función se debe de memoizar. Memoize todas las funciones de consulta siempre y cuando no devuelvan resultados grandes ya que la memoización almacena los ultimos 16 resultados de la función y esto podria ocasionar que consuman mucha memoria. Aqui tambien puede indicar el tamaño del cache si es que especifica un numero en lugar de un booleano
 * @param invalidates Indica las funciones que al ser llamadas deben de invalidar el cache. Por ejemplo las funciones que agreguen, editen o borren registros.
 */
function cacheResourceFunction(key, func, memoize, invalidates) {
    if (memoize != null && memoize > 0 && invalidates) {
        throw new Error(`La funcion ${key} se definio para memoizar como para invalidar, solo se puede escoger una de las dos`);
    }
    //Hereramos la configuración de la función, esto para permitir cacheResources anidados
    memoize = memoize == null ? func.memoize : memoize;
    invalidates = invalidates == null ? func.invalidates : invalidates;
    //Extraemos la función original en caso de que esta función ya haya sido cacheada anteriormente, esto nos permite anidar varios cacheResources
    const origFunc = func.cacheResourceFunctionOriginalFunction || func;
    const memo = memoize == null ? origFunc : memoize > 0 ? moizeDeep(origFunc, memoize) : origFunc;
    const ret = getCacheResourceFunctionInstance(memo, invalidates || false);
    //Agregamos la propiedad invalidate() para borrar el cache del moize
    if (memoize != null) {
        ret.invalidate = () => {
            const mem = memo;
            if (typeof (mem.clear) == "function")
                mem.clear();
        };
    }
    //Establecemos la funcion original como referencia para los siguientes caches
    ret.cacheResourceFunctionOriginalFunction = origFunc;
    ret.invalidates = invalidates;
    ret.memoize = memoize;
    return ret;
}
exports.cacheResourceFunction = cacheResourceFunction;
//# sourceMappingURL=cachefunction.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kea-resource/dist/cache/cachefunction.js
// module id = 2266
// module chunks = 0